export default "__VITE_ASSET__7dc00525__"